// extracted by css-extract-rspack-plugin
export default {"tagContainer":"Tag-module__tagContainer","tagName":"Tag-module__tagName","tag":"Tag-module__tag","desktop":"Tag-module__desktop"};